
















import Vue from "vue";
import userManager from "@/services/userManager";
import StatisticsPage from "@/components/StatisticsPage.vue";
import coreApiClient from "@/services/apis/coreApiClient";

export default Vue.extend({
  components: { StatisticsPage },
  data() {
    return {
      self: this,
      userManager,
      orderFields: [
        { value: "revenue", text: "DSDK MKT" },
        { value: "returnPercentage", text: "% Return" },
        { value: "count", text: "Tổng số đơn" },
      ],
      extraFiltersOptions: {
        count: {
          label: "Tổng số đơn",
          clearable: true,
          items: [
            {
              value: "",
              text: "Tất cả",
            },
            {
              value: "0_50",
              text: "0-50",
            },
            {
              value: "50_200",
              text: "50-200",
            },
            {
              value: "200_",
              text: ">200",
            },
          ],
        },
        creatorChannelTypesPickerOptions: {
          attrs: {
            label: "Loại kênh",
            "item-value": "_id",
            "item-text": "name",
            "item-disabled": "_",
            multiple: true,
          },
          content: {
            async itemsSuggestor(search, value, limit) {
              const filters = [
                {
                  key: "_id",
                  operator: "equal_to",
                  value,
                },
              ];
              const { items } = await coreApiClient.call("creatorChannelTypes", "findAll", {
                payload: JSON.stringify({
                  limit,
                  search,
                  filters,
                }),
              });
              return items;
            },
          },
        },
        creatorOwnerUserPickerOptions: {
          attrs: {
            label: "Chủ kênh",
            "item-value": "_id",
            "item-text": "name",
            "item-disabled": "_",
            multiple: true,
          },
          content: {
            async itemsSuggestor(search, value, limit) {
              const filters = [
                {
                  key: "_id",
                  operator: "equal_to",
                  value,
                },
              ];
              const { items } = await coreApiClient.call("users", "findAll", {
                payload: JSON.stringify({
                  limit,
                  search,
                  filters,
                }),
              });
              return items;
            },
          },
        },
      },
    };
  },
});
